import type { Changelog } from './changelog';

/**
 * Auto release notes for Firebase App Distribution (UCH-418): one bullet per
 * PR from the frozen changelog, falling back to commit subjects.
 */
export const generateReleaseNotes = (changelog: Pick<Changelog, 'prs' | 'commits'>): string => {
  if (changelog.prs.length > 0) {
    return [...changelog.prs]
      .sort((a, b) => a.number - b.number)
      .map((pr) => `- ${pr.title} (#${pr.number})`)
      .join('\n');
  }
  return changelog.commits.map((c) => `- ${c.subject}`).join('\n');
};
